import * as Routes from './routes';

do ->
  'use strict'

  captureOptions = (select) ->
    select.find('option').map((_, opt) ->
      text: $(opt).text()
      value: $(opt).attr('value') || ''
    ).get()

  applyOptions = (select, options) ->
    select.find('option').remove()
    if Array.isArray(options)
      for opt in options
        continue unless opt? and opt.text?
        option = new Option(opt.text, opt.value ? '', false, false)
        select.append(option)
    select.val('').trigger('change.select2')
    return

  placeholderFrom = (options, fallback) ->
    return fallback unless Array.isArray(options)
    for opt in options
      if ((opt?.value ? '') == '') and opt?.text?
        return opt.text
    fallback

  placeholderOption = (text) ->
    text: text
    value: ''

  $(document).on 'turbolinks:load', ->
    filterForm = $('#processos-workflows-filter')
    return unless filterForm.length

    sistemaSelect = filterForm.find('select[name="sistema"]')
    tipoSelect    = filterForm.find('select[name="tipo_processo_id"]')
    assuntoSelect = filterForm.find('select[name="assunto_processo_id"]')

    initialTipoOptions    = captureOptions(tipoSelect)
    initialAssuntoOptions = captureOptions(assuntoSelect)

    tipoPlaceholderText    = placeholderFrom(initialTipoOptions, 'TODOS OS TIPOS')
    assuntoPlaceholderText = placeholderFrom(initialAssuntoOptions, 'TODOS OS ASSUNTOS')

    resetTipo = (disable = true) ->
      applyOptions(tipoSelect, [placeholderOption(tipoPlaceholderText)])
      tipoSelect.prop('disabled', disable).trigger('change.select2')
      return

    resetAssunto = (disable = true) ->
      applyOptions(assuntoSelect, [placeholderOption(assuntoPlaceholderText)])
      assuntoSelect.prop('disabled', disable).trigger('change.select2')
      return

    setAssuntoOptions = (collection) ->
      options = [placeholderOption(assuntoPlaceholderText)]
      if Array.isArray(collection)
        for item in collection
          continue unless item?.id? && item?.nome?
          options.push(text: item.nome, value: item.id)
      applyOptions(assuntoSelect, options)
      assuntoSelect.prop('disabled', false).trigger('change.select2')
      return

    setTipoOptions = (collection) ->
      options = [placeholderOption(tipoPlaceholderText)]
      if Array.isArray(collection)
        for item in collection
          if Array.isArray(item) && item.length >= 2
            options.push(text: item[0], value: item[1])
      applyOptions(tipoSelect, options)
      tipoSelect.prop('disabled', false).trigger('change.select2')
      return

    mapSistemaParam = (value) ->
      return 'true'  if value == 'spu_evolucao'
      return 'false' if value == 'spu_virtual'
      ''

    if sistemaSelect.val()
      tipoSelect.prop('disabled', false).trigger('change.select2')
    else
      resetTipo()

    if tipoSelect.val()
      assuntoSelect.prop('disabled', false).trigger('change.select2')
    else
      resetAssunto()

    sistemaSelect.off('change.processosFiltro').on 'change.processosFiltro', ->
      sistemaValue = $(this).val()
      resetTipo()
      resetAssunto()
      param = mapSistemaParam(sistemaValue)

      if param == ''
        return

      $.getJSON(Routes.get_tipos_processos_workflows_path({sistema: param})).done((data) ->
        setTipoOptions(data?.tipos)
        return
      ).fail((xhr) ->
        console.error('Nao foi possivel carregar os tipos para o sistema selecionado.', xhr)
        resetTipo()
        return
      )
      return

    tipoSelect.off('change.processosFiltro').on 'change.processosFiltro', ->
      tipoId = $(this).val()
      resetAssunto()
      return unless tipoId

      params = { tipo_id: tipoId }
      sistemaValue = sistemaSelect.val()
      sistemaParam = mapSistemaParam(sistemaValue)
      params.sistema = sistemaParam if sistemaParam

      assuntoSelect.prop('disabled', true).trigger('change.select2')
      $.getJSON(Routes.assuntos_processos_path(params)).done((data) ->
        setAssuntoOptions(data)
        return
      ).fail((xhr) ->
        console.error('Nao foi possivel carregar os assuntos para o tipo selecionado.', xhr)
        resetAssunto()
        return
      )
      return

    return

  return
